import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";

import metaActions from "../../state/meta/actions";
import store from "../../store";

class FretboardStringHead extends PureComponent {
	static propTypes = {
		scope: PropTypes.string,
		string: PropTypes.number
	};

	onMouseOver = debounce(() => {
		store.dispatch(metaActions.update({ highlight: null }));
	}, 200, { leading: true, trailing: false })

	render() {
		let { scope = "row", string: n } = this.props;

		return (
			<th
				scope={scope}
				className="stringhead"
				title={`String ${1 + n}`}
				onMouseOver={this.onMouseOver}>
				{ 1 + n }
			</th>
		);
	}
}

export default FretboardStringHead;
